<template>
    <div class='common page-btns-father'>
        <div class="page-btns-main">
            <div class="page-main no-shadow">
                <a-steps :current="current" class="common-step">
                    <a-step v-for="item in steps" :key="item.title" :title="item.title" ></a-step>
                </a-steps>
            </div>
            <div class="">
                <keep-alive><component ref="bankComp" :is="steps[current].comp" :params.sync="steps[current].params" :text="steps[current].text" @success="success"></component></keep-alive>
            </div>
        </div>
        <div class="spaceCenter page-bottom-btns">
            <template v-if="current == 0">
                <a-button style="margin-left: 8px" class="btn-big" @click="goback">取消</a-button>
                <a-button style="margin-left: 8px" class="btn-big" @click="next">下一步</a-button>
            </template>
            <template v-if="current == 1">
                <a-button style="margin-left: 8px" class="btn-big" @click="prev">上一步</a-button>
                <a-button style="margin-left: 8px" class="btn-big" @click="goback">取消</a-button>
                <a-button style="margin-left: 8px" class="btn-big" @click="next">下一步</a-button>
            </template>
            <template v-if="current == 2">
                <a-button style="margin-left: 8px" class="btn-big" @click="prev">上一步</a-button>
                <a-button style="margin-left: 8px" class="btn-big" @click="goback">取消</a-button>
                <a-button style="margin-left: 8px" class="btn-big" @click="submit">提交</a-button>
            </template>
        </div>
    </div>
</template>

<script>
import goldFinancingStep1 from "./gold-financing-step1"
import goldFinancingStep2 from "./gold-financing-step2"
import goldFinancingStep3 from "./gold-financing-step3"
export default {
    name:"bankComp",
    components: {
        goldFinancingStep1,goldFinancingStep2,goldFinancingStep3
    },
    data() {
        return {
            current:0,
            steps:[
                {
                    title: '选择资金方',
                    comp:"goldFinancingStep1",
                    params:null
                },
                {
                    title: '补充贸易背景',
                    comp:"goldFinancingStep2",
                    params:null
                },
                {
                    title: '融资信息确认',
                    comp:"goldFinancingStep3",
                },
            ]
        };
    },
    computed: {},
    methods: {
        next() {
            this.$refs["bankComp"].check().then(res => {
                this.current++;
                this.steps[this.current].params = res;
            }).catch(err => {
                console.log(err);
            });
        },
        prev() {
            this.current--;
        },
        submit(){
            this.$refs["bankComp"].submit();
        },
        success(){
            this.goback();
        },
        goback(){
            this.MENUAPI.goToOneTab({
                path:"circulation/borrow"
            })
        }
    },
    created() {
        if(JSON.stringify(this.$route.params) == '{}'){
            this.goback();
        }
        this.steps[0].params = this.$route.params;
    },
    watch: {}
}
</script>
<style scoped>
    .common-step{
        width: 70%;
        margin:18px auto;
    }
</style>



// WEBPACK FOOTER //
// src/pages/circulation/gold-financing/gold-financing-steps/index.vue